import { useSiteSettings } from "@/hooks/useSiteData";
import whatsappIcon from "@/assets/whatsapp.png";

export default function WhatsAppButton() {
  const settings = useSiteSettings();
  const message = encodeURIComponent("שלום, אשמח לקבל פרטים על טיפולים במרפאה");
  return (
    <a
      href={`https://wa.me/${settings.whatsapp}?text=${message}`}
      target="_blank"
      rel="noreferrer"
      aria-label="צור קשר עם בית הרופאים באקה בוואטסאפ"
      className="fixed bottom-24 left-6 z-40 group sm:bottom-24"
    >
      <span className="absolute inset-0 rounded-full bg-green-500/40 blur-xl group-hover:bg-green-500/60 animate-glow-pulse" />
      <img
        src={whatsappIcon}
        alt="אייקון וואטסאפ של בית הרופאים באקה"
        width={56}
        height={56}
        decoding="async"
        className="relative h-14 w-14 rounded-full shadow-lg hover:scale-110 transition-transform"
      />
    </a>
  );
}
